import {computed, ref} from 'vue';
import {defineStore} from 'pinia';
import {useAuth} from '#imports';
import {readonlyState} from '@malt/utils';

/**
 * Basic informations on connected user
 */
export const useUserStore = defineStore('user-store', () => {
    const authStore = useAuth();
    const userLocale = ref<string>('');

    const userName = computed(() => authStore.user?.username || '');
    const selectedIdentity = computed(() => authStore.user?.identities.find((identity) => identity.id === authStore.user?.selectedIdentity));
    const userAccountId = computed(() => authStore.user?.id);
    const companyId = computed(() => selectedIdentity.value?.clientCompanyId || '');
    const serviceLevel = computed(() => authStore.user?.extraInformation?.serviceLevel || 'STANDARD');
    const clientCompanies = computed(() => authStore.user?.identities.filter((identity) => identity.identityType === 'CLIENT'));

    const isAdmin = computed(() => {
        if (selectedIdentity.value) {
            return selectedIdentity.value.admin;
        }
        return false;
    });

    const isPlatformAdmin = computed(() => {
        return authStore.hasEnoughPrivilege(['ROLE_ADMIN']);
    });

    const isPOMandatory = computed(() => {
        return authStore.user?.extraInformation?.memberOfCompanyWithPOMandatory === 'true';
    });

    const roles = computed(() => {
        return authStore.user?.roles || [];
    });

    return {
        isAdmin,
        isPlatformAdmin,
        userLocale,
        selectedIdentity,
        userName,
        companyId,
        roles,
        clientCompanies,
        userAccountId,
        isPOMandatory,
        serviceLevel: readonlyState(serviceLevel),
    };
});
